var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"tip-bar"},[_c('div',{staticClass:"scroll-tip",on:{"click":_vm.scrollDown}},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }